const dictionary = {
  // NewClient.
  newClient_title: 'Nuevo Cliente',
  newClient_subtitle: 'Complete y/o verifique los datos del cliente',
  // AlertRisk
  alertRisk_loading: 'Verificando estado...',
  alertRisk_initial_text:
    'Una vez ingresado Nombre, Apellido y seleccionado el sexo, automáticamente se realizará la Verificación de riesgo y Deuda',
  alertRisk_initial_text_ruc:
    'Una vez ingresada la Razón Social, automáticamente se realizará la Verificación de riesgo y Deuda',
  alertRisk_riesgo: 'Riesgo:',
  alertRisk_motivo: 'Motivo:',
  alertRisk_scoring: 'Scoring:',
  //DebtAlert
  debtAlert_debt: 'Deuda:',
  //ExemptionCardAlert
  exemptionCardAlert_exemptionCard: 'Tarjeta de Exoneración N° ',
  // ClientForm
  clientForm_subtitle: 'Información personal',
  clientForm_ruc_subtitle: 'Datos del Responsable',
  clientForm_contact_subtitle: 'Datos de contacto',
  clientForm_label_company: 'Razón social',
  clientForm_label_documentType: 'Tipo de Doc.',
  clientForm_label_documentNumber: 'Nro. de Doc.',
  clientForm_label_name: 'Nombre/s',
  clientForm_label_surname: 'Apellido/s',
  clientForm_label_sex: 'Sexo',
  clientForm_label_sex_m: 'Masculino',
  clientForm_label_sex_f: 'Femenino',
  clientForm_label_sex_m_ruc: 'M',
  clientForm_label_sex_f_ruc: 'F',
  clientForm_label_birthDate: 'Fecha de Nacimiento',
  clientForm_label_birthDate_ruc: 'Fecha de Nac.',
  clientForm_label_email: 'Email',
  clientForm_label_phoneType: 'Teléfono',
  clientForm_label_areaCode: 'Cod. Área',
  clientForm_label_phoneNumber: 'Nro. de Tel',
  clientForm_label_phoneCompany: 'Empresa',
  clientForm_adictionalContact_subtitle: 'Contacto Adicional',
  clientForm_adictionalContact_addButton: 'AÑADIR CONTACTO',
  clientForm_delete_contact_modal_title:
    '¿Estás seguro que querés eliminar este contacto adicional?',
  // ClientInfo
  clientInfo_title: 'Cliente',
  clientInfo_subtitle: 'Complete y/o verifique los datos del cliente',
  clientInfo_missingInfoModal_title: 'Falta cargar datos personales',
  clientInfo_missingInfoModal_text:
    'Para poder continuar el pedido, por favor comunicáte con Recursos Humanos.',
  clientInfo_debtModal_authorized_title: 'El cliente posee deuda',
  clientInfo_debtModal_notAuthorized_title:
    'No se puede continuar con la carga de datos',
  clientInfo_debtModal_authorized_text:
    'Si deseas, puedes continuar con la venta como excepción.',
  clientInfo_debtModal_not_authorized_text:
    'Para continuar, regularice su situación.',
  // Client Validation
  client_blackList: 'Dominio inválido. Ingrese uno nuevo, por favor.',
  client_emailFormat:
    'Solo se permiten letras (a-z sin ñ)  Numeros (0-9) y puntos (.)',
  // Portability
  portability_label_number: 'Nro. de teléfono a Portar',
  portability_btn: 'PORTABILIDAD',
  portability_warn_modal: 'No se puede continuar con la portación',
  // other
  search_btn: 'BUSCAR',
  attention_with_exclamation_mark: '¡Atención!',
  attention: 'Atención',
  // SearchAddress
  searchAddress_title: 'Buscar por Domicilio',
  searchAddress_subtitle:
    'Ingresar al mapa para realizar una búsqueda de acuerdo al domicilio de instalación',
  // SearchDocument
  searchDocument_title: 'Buscar por Documento',
  searchDocument_subtitle: 'Seleccione tipo e ingrese número de documento',
  searchDocument_label_docType: 'Tipo de Documento',
  searchDocument_label_docNumber: 'Números',
  // SearchSDS
  searchSDS_title: 'Ver SDS Generadas',
  searchSDS_subtitle: 'Ingrese el número de SDS o de OT para generar su PDF',
  searchSDS_label_sdsOtType: 'SDS u OT',
  searchSDS_sdsOtNumber: 'Número',
  // SdsHistoricTable
  sdsHistoric_title: 'SDS Generadas',
  sdsHistoric_creationDate: 'Fecha',
  sdsHistoric_idSDS: 'SDS',
  sdsHistoric_stateDescription: 'Status',
  sdsHistoric_workOrderId: 'Número OT',
  sdsHistoric_numeroOT: 'Número OT',
  sdsHistoric_identificationNumber: 'Documento',
  sdsHistoric_clientFullName: 'Nombre y Apellido',
  sdsHistoric_billingCity: 'Localidad',
  sdsHistoric_product: 'Producto',
  sdsHistoric_portableNumber: 'Portabilidad',
  // NoSDS
  noSDS_title: '¡Por ahora no tenés SDS creadas!',
  header_entity_label: 'Entidad: ',
  header_file_label: 'Legajo: ',
  header_agent_label: 'Usuario: ',
  header_agentCI_label: 'Vendedor: CI ',
  // header change entity modal
  header_changeEntityModal_title: 'Cambio de Entidad/Vendedor',
  header_changeEntityModal_entity_seller_text:
    'Al cambiar de entidad o vendedor se perderán todos los datos no guardados.',
  // header logout modal
  header_logoutModal_title: '¿Está seguro que desea cerrar sesión?',
  header_logoutModal_text:
    'Al cerrar la sesión se perderán todos los datos no guardados.',
  // EntitiesForm
  header_entitiesForm_label: 'Seleccione Entidad',
  header_entitiesForm_submitBtn: 'INGRESAR',
  // headerMenu
  header_menu_changeEntity_seller: 'Cambiar Entidad/Vendedor',
  header_menu_logout: 'Cerrar Sesión',
  // Summary
  summary_isEmployeeFlow_not_hasSdsError:
    'Nos contactaremos a la brevedad para continuar con tu pedido.',
  summary_isUfinetProvider:
    'La solicitud está siendo creada. <br/> Por favor, esperá unos segundos...',
  summary_sectionHeading_title: 'Resumen de Solicitud de Servicio',
  summary_client_data: 'Datos del Cliente',
  summary_ruc: 'RUC',
  summary_company: 'Razón Social',
  summary_responsible_applicant: 'Solicitante Responsable',
  summary_document: 'Documento',
  summary_name_and_last_name: 'Nombre y apellido',
  summary_sex: 'Sexo',
  summary_birth_date: 'Fecha de nacimiento',
  summary_telephone: 'Teléfono',
  summary_email: 'Email',
  summary_exoneration_card: 'Tarjeta de Exoneración N°',
  summary_portability: 'Portabilidad',
  summary_address: 'Domicilio',
  summary_latitude_longitude: 'Latitud y longitud',
  summary_address_street: 'Calle y número',
  summary_optional_address_street_number: 'Calle y número opcional',
  summary_address_flat: 'Piso y Apart.',
  summary_tower_block_lot: 'Torre/Bloque/Lote',
  summary_cp: 'CP',
  summary_address_within_streets: 'Entre calles',
  summary_address_suburb: 'Barrio',
  summary_address_city: 'Localidad',
  summary_region_name: 'Departamento',
  summary_address_observations: 'Observaciones',
  summary_observations: 'Observaciones',
  summary_plans: 'Planes',
  summary_plans_and_services: 'Planes y Servicios',
  summary_service: 'Servicio',
  summary_deco_quantity: 'Decodificadores',
  summary_bonus: 'Bonificación',
  summary_without_bonus: 'Total por mes sin bonificación',
  summary_bonus_internet: 'Prorrateo internet',
  summary_bonus_error_label: 'Error: ',
  summary_monthly_cost: 'Costo mensual',
  summary_billing: 'Facturación',
  summary_payment_method: 'Método de pago',
  summary_condition_iva: 'Condición de IVA',
  summary_billing_address: 'Domicilio de facturación',
  summary_invoice_type: 'Tipo de factura',
  summary_condition_IIBB: 'Condición de IIBB',
  summary_number_IIBB: 'Nro. de IIBB',
  summary_generate_sds: 'GENERAR SDS',
  summary_tiered_bonus_discount: 'Bonificación Escalonada',
  summary_tiered_bonus_error_without_flag:
    'Actualmente no será posible consultar los escalones, de todas maneras, puedes continuar con la venta normalmente.',
  summary_tiered_bonus_error_with_flag:
    'En este momento no pueden visualizarse los escalones, de todas maneras, puedes continuar con la venta normalmente.',
  summary_tiered_bonus_accordion_title_wifi: 'Internet Wi-Fi',
  summary_tiered_bonus_accordion_title_iptv_subscription: 'TV HD',
  summary_tiered_bonus_accordion_title_dth_subscription: 'Claro TV',
  summary_tiered_bonus_grid_header_step: 'Escalón',
  summary_tiered_bonus_grid_header_bonus: 'Bonif. %',
  summary_tiered_bonus_grid_header_discount: 'Descuento',
  summary_tiered_bonus_grid_header_total: 'Total',
  summary_tiered_bonus_bottom_footnote:
    '*Precio simulado puede cambiar según actualizaciones en el precio del plan.',
  // Domicilie
  domicilie_title: 'Domicilios del Cliente',
  domicilie_subtitle_new_domicile: 'Ingresá Nuevo Domicilio',
  domicile_subtitle_select_domicile:
    'Seleccioná el Domicilio con el que deseas trabajar',
  domicile_subtitle_select_existing_domicile:
    ' o seleccioná uno de los existentes',
  domicilie_accept: 'ACEPTAR',
  domicilie_isEmployeeFlow:
    'El domicilio posee servicio comercial. Para poder aplicarle beneficios EMPLE comunicarse con RRHH',
  domicile_iva_conditions_disparity_modalTitle:
    'La condición de IVA de la cuenta no coincide',
  domicile_iva_conditions_not_authorized_Modaltext:
    'Para continuar, regularice esta situación en Atención al Cliente',
  domicilie_no_isEmployeeFlow:
    'El domicilio seleccionado tiene servicio EMPLE, indicar al solicitante que debe autogestionarse',
  domicilie_gpon_modal:
    'No se puede realizar un Upgrade en esta línea por no contar con tecnología GPON. Comuníquese con el área de Posventa para poder continuar.',
  domicilie_dth_modal:
    'No se puede realizar un Upgrade en esta línea por no contar con tecnología DTH. Comuníquese con el área de Posventa para poder continuar.',
  domicile_dth_limit_deco_modal:
    'No es posible instalar en este domicilio. Límite de servicios alcanzado.',
  domicile_dth_suspended_lines_modal:
    'El domicilio tiene al menos una línea  suspendida y no puede adherir nuevos servicios en el mismo.',

  // DomicilioDetail
  domicilioDetail_title: 'Domicilios del Cliente',
  domicilioDetail_subtitle:
    'Dirección donde se realizará la instalación del servicio ubicada en: ',
  domicileDetail_lat: 'latitud ',
  domicileDetail_long: ' y longitud ',
  domicileDetail_lat_long_not_available:
    'Datos de latitud y longitud no disponibles.',
  // DomicileForm
  domicileForm_detailManzana: 'Manzana',
  domicileForm_detailLote: 'Lote',
  domicileForm_detailCalle: 'Calle',
  domicileForm_detailOptionalStreet: 'Calle Opcional',
  domicileForm_detailNumCalle: 'Número',
  domicileForm_detailOptionalStreetNumber: 'Número Opcional',
  domicileForm_detailPiso: 'Piso',
  domicileForm_detailDpto: 'Apartamento',
  domicileForm_detailTorre: 'Torre/Bloque/Lote',
  domicileForm_detailEntreCalle: 'Entre calles',
  domicileForm_detailSuburb: 'Barrio',
  domicileForm_detailLocalidad: 'Localidad',
  domicileForm_detailPartido: 'Partido',
  domicileForm_detailProvincia: 'Departamento',
  domicileForm_detailCodigoPostal: 'Código Postal',
  domicileForm_detailObservaciones: 'Observaciones',
  domicileForm_edit: 'EDITAR DOMICILIO',
  domicileForm_confirm: 'CONFIRMAR DOMICILIO',
  domicileForm_mapField_initialMessage: 'Faltan cargar los siguientes datos',
  domicileForm_mapField_endMessage:
    'Por favor, ingréselos por Stealth y luego continúe con la operación.',
  domicileForm_initialMessage_addressWithinStreets: 'Ingresa los datos de',
  domicileForm_endMessage_addressWithinStreets:
    'para continuar con la operación.',
  // DomicileSubtitle
  domicileSubtitle_subtitleLink: 'Ingresá Nuevo Domicilio',
  // FilterDomicileList
  filterDomicileList_region: 'Provincia',
  filterDomicileList_localidad: 'Ciudad',
  filterDomicileList_street: 'Calle/Manzana',
  filterDomicileList_streetNumber: 'Número/Lote',
  filterDomicileList_flat: 'Piso',
  filterDomicileList_department: 'Departamento',
  filterDomicileList_search: 'BUSCAR',
  // FilterFields
  filterFields_time: 'Tiempo',
  filterFields_segment: 'Segmento',
  filterFields_business: 'Negocio',
  filterFields_region: 'Provincia',
  filterFields_department: 'Partido',
  // map-errors-to-async-loader
  mapErrorsToAsyncLoader_scheduledChange_errorTitle:
    '¡Lo siento! El Cliente cuenta con un Cambio de Cuenta Programado',
  mapErrorsToAsyncLoader_scheduledChange_Sorry: '¡Lo siento!',
  // SearchDomicile
  searchDomicile_error: 'Error en la búsqueda. Intente de nuevo.',
  searchDomicile_search_requested:
    'No se encontró ningún resultado en la búsqueda solicitada.',
  searchDomicile_try_again: 'Intente de nuevo.',
  // SearchDomicileTable
  searchDomicileTable_regionName: 'Provincia',
  searchDomicileTable_addressCity: 'Ciudad',
  searchDomicileTable_addressStreet: 'Calle/Manzana',
  searchDomicileTable_addressNumber: 'Número/Lote',
  searchDomicileTable_addressFlat: 'Piso',
  searchDomicileTable_addressFloor: 'Depto.',
  // ShowSdsDomicile
  showSdsDomicile_address_without_preExisting_SDS:
    'Domicilio sin SDS preexistentes',
  showSdsDomicile_changeentity_modal_title: 'Detalle de SDS',
  showSdsDomicile_numberOT: 'Número OT',
  showSdsDomicile_stateOT: 'Estado OT',
  showSdsDomicile_ReasonOT: 'Motivo OT',
  // Login
  login_subtitle: 'Ingresar con usuario y password',
  login_title: 'Login',
  // LoginForm
  loginForm_name: 'Usuario',
  loginForm_pass_label: 'Password',
  loginForm_continueBotton: 'CONTINUAR',
  // EntitiesPage
  entitiesPage_title: 'Bienvenido',
  entitiesPage_subtitle:
    'Ingrese el id de la entidad sobre la que desea trabajar, de esta forma quedara registrado el agente y la entidad que estan realizando la operación.',
  // billingDetailForm
  billingDetailForm_tipoFactura_label: 'Tipo de Factura',
  billingDetailForm_tipoFactura_electronica_label: 'Electrónica',
  billingDetailForm_tipoFactura_papel_label: 'En Papel',
  billingDetailForm_email_label: 'Email',
  billingDetailForm_domicileDescription_label: 'Domicilio',
  billingDetailForm_domicile_normalize_button: 'NORMALIZAR',
  billingDetailForm_domicile_cp_label: 'CP: 1',
  billingDetailForm_normalizeBtn_next: 'SIGUIENTE',
  billingDetailForm_condicionIVA_label: 'Condición de IVA',
  billingDetailForm_formaPago_label: 'Forma de Pago',
  billingDetailForm_associatedPhone_label: 'Línea Notificante FE',
  // creditCardSubForm
  creditCardSubForm_cardNumber_label: 'Número de tarjeta',
  creditCardSubForm_expiration_label: 'Vencimiento',
  // accountDebitSubForm
  accountDebitSubForm_cbuNumber_label: 'Número de CBU',
  // billingAccounts
  billingAccounts_subtitleLink: 'Creá una nueva',
  billingAccounts_notAllowedForSelfManagement:
    'Esta cuenta NO está habilitada para Autogestión de Empleados',
  billingAccounts_selfManagement:
    'Esta cuenta es solo para Autogestión de Empleados',
  // billingAccountCard
  billingAccountCard_accountNumber: 'N° Cuenta',
  billingAccountCard_paymentMethod: 'Método de pago',
  billingAccountCard_associatedProducts: 'Productos asociados a esta cuenta',
  // App
  app_asyncLoader_errorMessage:
    'Ocurrió un error al intentar cargar la configuración inicial',
  app_modal_ok_label: 'ACTUALIZAR',
  // alert
  alert_alertLink_label: 'Vuelva a intentarlo',
  // formSubTitle.stories
  formSubTitle_stories_field_name: 'Nombre/s',
  formSubTitle_stories_field_surname: 'Apellido/s',
  // inputTextFilter
  input_text_filter_input_placeholder: 'Filtrar...',
  // submitButton.stories
  submitButton_stories_field_name: 'Nombre/s',
  submitButton_stories_field_surname: 'Apellido/s',
  // CreditCardNumberField
  creditCardNumberField_custom_text_field_label: 'Número de tarjeta',
  // WebCoberturaDialog
  webCoberturaDialog_modal_okLabel: 'ACEPTAR',
  webCoberturaDialog_modal_cancelLabel: 'VOLVER',
  // ValidateClientOwnership
  validateClientOwnership_searchDocument_confirmNamebutton: 'BUSCAR',
  // TimeoutMessage
  timeoutMessage_SDS: 'La SDS aún está siendo procesada',
  timeoutMessage_go_to_start: 'IR AL INICIO',
  // WarningScreen
  warningScreen_title_default:
    '¡Lo siento! Por ahora no está disponible esta información.',
  warningScreen_message_default: 'Volvé a intentarlo más tarde',
  // EditDomicileModal
  editDomicileModal_billing_address: 'Domicilio de Facturación',
  editDomicileModal_normalizing: 'Normalizando',
  editDomicileModal_domicile: 'Domicilio',
  editDomicileModal_province: 'Departamento',
  editDomicileModal_city: 'Localidad',
  editDomicileModal_suburb: 'Barrio',
  editDomicileModal_street: 'Calle',
  editDomicileModal_number: 'Número',
  editDomicileModal_floor: 'Piso',
  editDomicileModal_department: 'Apto.',
  editDomicileModal_tower_block_lot: 'Torre/Bloque/Lote',
  editDomicileModal_observations: 'Observaciones',
  editDomicileModal_next: 'NORMALIZAR',
  editDomicileModal_save: 'GUARDAR',
  // AddressCard
  addressCard_residential_services: 'Servicios Residenciales',
  addressCard_line_status: 'Estado de línea',
  addressCard_domicile: 'Domicilio',
  addressCard_block_and_lot: 'Manzana y Lote',
  addressCard_street: 'Calle',
  addressCard_number: 'Número',
  addressCard_floor: 'Piso',
  addressCard_department: 'Apartamento',
  addressCard_tower_block_lot: 'Torre',
  addressCard_cpa: 'CP',
  addressCard_between_streets: 'Entre Calles',
  addressCard_suburb: 'Barrio',
  addressCard_location: 'Localidad',
  addressCard_province: 'Departamento',
  addressCard_products_associated_with_this_Account:
    'Productos asociados a esta Cuenta',
  addressCard_product: 'Producto',
  addressCard_plan: 'Plan',
  addressCard_STB: 'Cantidad STB Activos',
  addressCard_deco: 'Cantidad DECO Activos',
  addressCard_account_number: 'N° Cuenta: ',
  // AgentDocumentNumberField
  AgentDocumentNumberField_label: 'Número de CI del Agente',
  // ClaroTv
  claro_tv_button_next: 'SIGUIENTE',
  // PDF
  pdf_button_next: 'VER SDS',
  // Plans dth flow
  principal_service_plan: 'PRINCIPAL',
  additional_service_plan: 'ADICIONAL',
  planFormClaroTv_campaigns_label: 'Campañas',
  planFormClaroTv_promotions_label: 'Promociones',
  planFormClaroTv_campaigns_select_placeholder: 'Selecciona una Campaña *',
  planFormClaroTv_campaigns_helper_title: 'Debes seleccionar una Campaña.',
  planFormClaroTv_campaigns_helper_subtitle:
    'Para continuar con la venta, selecciona una campaña',
  planFormClaroTv_decos_section: 'Decodificadores',
  //DecosDth
  decosDth_already_has_a_deco:
    'El cliente ya posee 1 decodificador instalado en su domicilio.',
  decosDth_labelCounter: 'Cantidad',
  //SummaryDetailsDTH
  summaryDetailsDth_claroTv_title: 'Claro TV',
  summaryDetailsDth_decos: 'Decodificador adicional',
  summaryDetailsDth_total: 'Total por mes',
  summaryDetailsDth_deco_quantity_to_add: 'Cantidad',
  summaryDetailsDth_total_without_bonus: 'Total por mes sin bonificación',
  // AssociatedEmail
  associated_email: 'Email asociado',
  alert_plan_form_email_already_validated:
    'E-mail disponible para ser registrado en AMCO.',
  rucMessageFailAmcoConnection:
    'Reintenta o continúa con la venta dejando el campo vacío.',
  defaultFailAmcoConnectionMessage: 'Por favor, reintenta.',
  // Others
  summary: 'Resumen',
  understood_label: 'ENTENDIDO',
  // SdsResponseMessage
  view_pdf_title: 'VER SDS',
  // AssociatedPhone
  associatedPhone_label_areaCode: 'Cod. Área',
  associatedPhone_label_phoneLine: 'N° de Teléfono',
  validate_button: 'VALIDAR',
  already_validate_button: 'VALIDADO',
  // SearchSdsOT
  searchSdsOT_retry: 'Reintentar',
  // SdsPdf
  sdsPdf_error_modal:
    'Hubo un error al generar el PDF. Por favor, inténtalo nuevamente.',
};

export default dictionary;
